<template>
  <b-sidebar
    v-model="modalOpen"
    centered
    id="centreModal"
    class="edit-modal"
    width="500px"
    backdrop
    no-close-on-backdrop
    no-close-on-esc
    no-header
    body-class="bg-white"
  >
    <div class="p-2">
      <validation-observer ref="centreValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col class="d-flex justify-content-between" cols="12">
              <h3>معلومات المركز</h3>
              <feather-icon
                size="20"
                class="cursor-pointer"
                @click="modalOpen = false"
                icon="XIcon"
              />
            </b-col>
            <b-col cols="12">
              <hr />
            </b-col>
            <b-col cols="12">
              <form-input
                rules="required"
                label="اسم المركز"
                v-model="form.name"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="نوع المركز"
                id="center-type"
                v-model="form.service_centre_type_id"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name"
                ep="/v2/selects/service-centre-types"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="حالة المركز"
                id="center-status"
                v-model="form.status"
                :reduce="(x) => x.value"
                :getOptionLabel="(x) => x.title"
                :options="[
                  { title: 'فعال', value: true },
                  { title: 'متوقف', value: false },
                ]"
              />
            </b-col>
            <b-col cols="12">
              <form-input
                rules="required"
                label="رقم قرار الترخيص"
                v-model="form.clearance_decision_number"
              />
            </b-col>

            <b-col cols="12" class="mb-2">
              <span class="text-muted mt-1">
                <feather-icon icon="InfoIcon" /> قم بالضغط على رمز الخريطة للبحث
                عن الموقع</span
              >
            </b-col>
            <b-col cols="12" class="d-flex align-items-center">
              <form-input
                style="width: 40%"
                rules="required"
                label="خط الطول"
                v-model="form.longitude"
                readonly
              />
              <form-input
                class="mx-50"
                style="width: 40%"
                rules="required"
                label="خط العرض"
                v-model="form.latitude"
                readonly
              />
              <b-button
                @click="mapModal = true"
                class="btn btn-primary mt-50"
                variant="flat-primary"
              >
                <feather-icon icon="MapPinIcon" />
              </b-button>
            </b-col>

            <b-col class="mb-2" cols="12">
              <form-select
                label="رقم العقار"
                v-model="form.real_estate_id"
                :getOptionLabel="(x) => x.number"
                :reduce="(x) => x.id"
                id="real-estate-id"
                ep="v"
                ref="centreRealEstates"
                rules="required"
              />
              <small class="text-muted"
                >تظهر فقط أرقام العقارات للمحافظة التي قمت باختيارها</small
              >
            </b-col>

            <b-col cols="12">
              <form-select
                label="الجهة المرخصة"
                v-model="form.clearance_authority_id"
                :getOptionLabel="(x) => x.name"
                :reduce="(x) => x.id"
                id="clearanceAuth"
                ep="v2/selects/clearance-authorities"
                rules="required"
                ref="clearanceAuth"
              />
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="primary"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <b-modal
      v-model="mapModal"
      centered
      size="lg"
      title="موقع المركز الخدمي"
      footer-class="removed"
      class="edit-modal"
      id="branchModal"
    >
      <map-select
        govsEndpoint="v2/selects/branch-related-governorates?related=true"
        @markerUpdated="onLocationSelect"
        @closeModal="mapModal = false"
        noAddress
      >
        <form-input
          rules="required"
          label="العنوان التفصيلي"
          v-model="form.address"
        />
      </map-select>
      <!-- <b-row class="justify-content-end mt-1">
        <b-button @click="mapModal = false">إلغاء</b-button>
        <b-button variant="success" class="mx-1">تأكيد</b-button>
      </b-row> -->
    </b-modal>
  </b-sidebar>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import formInput from "@/components/form-input";
import formSelect from "@/components/form-select";
import vSelect from "vue-select";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import formDatepicker from "@/components/form-datepicker";
import formAutocomplete from "@/components/form-autocomplete";
import mapSelect from "@/components/map-select";
import { required, integer } from "@validations";

const initForm = {};
export default {
  components: {
    formAutocomplete,
    formInput,
    formTextarea,
    formSelect,
    BButton,
    formDatepicker,
    saveBtn,
    vSelect,
    mapSelect,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    BSidebar,
  },
  props: {
    value: Boolean,
    title: String,
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      govId: null,
      required,
      integer,
      mapModal: false,
      // options: [
      //   { id: 1, name: "مرتبط بالخطة" },
      //   { id: 0, name: "طارئ" },
      // ],
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          this.init(this.intializeForm);
        });
    },
    govId(val) {
      if (val) {
        this.$refs.centreRealEstates.refreshOptions(
          `v2/selects/real-estates?gid=${val}`
        );
        delete this.form.real_estate_id;
      }
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
      if (form.area && form.area.governorate) {
        this.govId = form.area.governorate.id;
        this.form.real_estate_id = form.real_estate_id;
      }
      delete this.form.area;
    },
    onLocationSelect({ pos, area, address, govId }) {
      this.form.longitude = pos.lng;
      this.form.latitude = pos.lat;
      this.form.area_id = area.id;
      this.govId = govId;
    },
    async onSubmit() {
      await this.$refs.centreValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>
